<template>
  <ActionsWrapper class="justify-between flex"
    :style="{padding:'16px'}"
  >
    <BaseButton
      color="inverse"
      @click="$emit('clear')"
    >
      Clear
    </BaseButton>

    <BaseButton
      color="green"
      :is-loading="isLoading"
      @click="$emit('submit')"
    >
      {{ submitLabel }}
    </BaseButton>
  </ActionsWrapper>
</template>

<script>
import ActionsWrapper from '@/components/Ui/ActionsWrapper.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

export default {
  name: 'ClearAndSubmit',
  emits: ['clear', 'submit'],
  components: { BaseButton, ActionsWrapper },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    submitLabel: {
      type: String,
      default: 'Submit',
    },
  },
};
</script>
